module.exports = __webpack_public_path__ + "img/PatenetApplicationNumber.47b978a3.png";